import { queryOptions } from "@tanstack/react-query";

import { DimensionValueSet } from "@/lib/dimensions";

export type LoadLegendImage = (
  dimensionValues: DimensionValueSet,
) => Promise<Blob | undefined>;

/**
 * Shared query definition for map-layer legend images. Couples the
 * `["map-layer-legend-image", …]` key to its `queryFn` so every consumer of the
 * key performs the same fetch; per-site options (placeholder, retry) are added
 * by spreading this into `useQuery`.
 */
export function legendImageQueryOptions(
  layerId: string,
  dimensionValues: DimensionValueSet,
  loadLegendImage: LoadLegendImage,
) {
  return queryOptions({
    queryKey: ["map-layer-legend-image", layerId, dimensionValues] as const,
    queryFn: async () => {
      const blob = await loadLegendImage(dimensionValues);
      return blob ? URL.createObjectURL(blob) : null;
    },
  });
}
